import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAddExpensePlanSchema = () => {
  const { t } = useTranslation();

  const schema = z.object({
    planName: z
      .string()
      .trim()
      .refine((value) => value !== "", {
        message: t("common.form.field.errors.required"),
      }),
    planAmount: z
      .number({ required_error: t("common.form.field.errors.required") })
      .or(
        z
          .string({ required_error: t("common.form.field.errors.required") })
          .trim()
          .refine((value) => value !== "", {
            message: t("common.form.field.errors.required"),
          }),
      ),
    transactionCategoryId: z.number({
      required_error: t("common.form.field.errors.required"),
    }),
    expensePlanIntervalId: z.string({
      required_error: t("common.form.field.errors.required"),
    }),
    bankAccountId: z.number().optional(),
  });

  return schema;
};
export type TAddExpensePlanSchema = z.infer<
  ReturnType<typeof useAddExpensePlanSchema>
>;
